var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67189 6.79147C3.07966 9.31071 2.51318 12.5733 2.51318 15.5132H2.01318C2.01318 12.5232 2.58707 9.15423 4.24923 6.52434C5.92144 3.87855 8.68473 2 13 2C17.3153 2 20.0786 3.87855 21.7508 6.52434C23.413 9.15423 23.9869 12.5232 23.9869 15.5132H23.4869C23.4869 12.5733 22.9204 9.31071 21.3282 6.79147C19.746 4.28813 17.1408 2.5 13 2.5C8.85921 2.5 6.25408 4.28813 4.67189 6.79147Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28947 15.3816H3C2.17157 15.3816 1.5 16.0532 1.5 16.8816V19.1974C1.5 20.0258 2.17157 20.6974 3 20.6974H4.28947V15.3816ZM3 14.8816C1.89543 14.8816 1 15.777 1 16.8816V19.1974C1 20.302 1.89543 21.1974 3 21.1974H4.78947V14.8816H3Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 15.3816H21.7106V20.6974H23C23.8285 20.6974 24.5 20.0258 24.5 19.1974V16.8816C24.5 16.0532 23.8285 15.3816 23 15.3816ZM21.2106 14.8816V21.1974H23C24.1046 21.1974 25 20.302 25 19.1974V16.8816C25 15.777 24.1046 14.8816 23 14.8816H21.2106Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6511 23.5757C18.3747 23.0303 18.9888 22.2604 19.7354 21.0649L20.1595 21.3297C19.4022 22.5422 18.7493 23.3741 17.9521 23.9749C17.1523 24.5778 16.227 24.9335 14.9514 25.2303L14.8381 24.7433C16.0811 24.4541 16.9302 24.1191 17.6511 23.5757Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1579 24.9868C16.1579 25.6844 15.5924 26.2499 14.8947 26.2499C14.1971 26.2499 13.6316 25.6844 13.6316 24.9868C13.6316 24.2892 14.1971 23.7236 14.8947 23.7236C15.5924 23.7236 16.1579 24.2892 16.1579 24.9868Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1053 11.7236C11.1053 12.0724 10.8226 12.3552 10.4737 12.3552C10.1249 12.3552 9.84216 12.0724 9.84216 11.7236C9.84216 11.3748 10.1249 11.092 10.4737 11.092C10.8226 11.092 11.1053 11.3748 11.1053 11.7236Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6316 11.7236C13.6316 12.0724 13.3488 12.3552 13 12.3552C12.6512 12.3552 12.3684 12.0724 12.3684 11.7236C12.3684 11.3748 12.6512 11.092 13 11.092C13.3488 11.092 13.6316 11.3748 13.6316 11.7236Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1579 11.7236C16.1579 12.0724 15.8752 12.3552 15.5264 12.3552C15.1775 12.3552 14.8948 12.0724 14.8948 11.7236C14.8948 11.3748 15.1775 11.092 15.5264 11.092C15.8752 11.092 16.1579 11.3748 16.1579 11.7236Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9473 11.7238C19.9473 13.0773 19.3691 14.3204 18.4037 15.2966V17.4082H13.7721L13 17.408C9.16306 17.408 6.05261 14.8631 6.05261 11.7238C6.05261 8.58445 9.16306 6.03955 13 6.03955C16.8369 6.03955 19.9473 8.58445 19.9473 11.7238ZM17.9037 15.0911L18.0481 14.945C18.9341 14.0492 19.4473 12.9282 19.4473 11.7238C19.4473 8.94973 16.6593 6.53955 13 6.53955C9.3407 6.53955 6.55261 8.94973 6.55261 11.7238C6.55261 14.4978 9.3407 16.908 13 16.908L14.2721 16.9082H17.9037V15.0911Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.36f2792b.svg";
export { ForwardRef as ReactComponent };